import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, webApiHeaders } from "../../apiConfig";
import { ProfileContext } from "../../context/ContextProfile";

import ProfileShell from "./ProfileShell";
import Header from "../../components/profile/Header";
import Footer from "../../components/profile/Footer";
import Gallery from "../../components/profile/gallery/Gallery";
import Silbina from "../../components/profile/Silbina";

// Public village profile from the API v2 web endpoint. An unknown village
// comes back as a 404, which resolves to `null` here (v1 answered 200 with a
// non-zero errorCode instead); any other failure rejects.
function fetchVillage(code) {
  return axios({
    method: "post",
    url: `${API_BASE}/v2/web/village-info`,
    headers: webApiHeaders,
    params: { code, isScan: 1 },
  })
    .then((res) => (res.data.errorCode === 0 ? res.data : null))
    .catch((error) => {
      if (error.response?.status === 404) return null;
      throw error;
    });
}

// Route: /:code  →  aldealista.com/<village> (the printed QR target).
// Resolves the code against the API and renders that village's profile.
export default function VillageProfile() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { modifyVillage } = useContext(ProfileContext);

  const [isMegaMatch, setIsMegaMatch] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Legacy static page, kept on the marketing host.
    if (code === "mapadeseorural") {
      window.location.replace("https://aldealista.com/mapadeseorural.html");
      return;
    }

    let active = true;
    setReady(false);

    fetchVillage(code)
      .then((data) => {
        if (!active) return;
        const found = data !== null;

        if (found) modifyVillage(data);

        // "silbina" always renders the megamatch variant, even without data.
        if (code === "silbina") {
          setIsMegaMatch(true);
          setReady(true);
        } else if (found) {
          setReady(true);
        } else {
          navigate("/", { replace: true });
        }
      })
      .catch(() => {
        if (active) navigate("/", { replace: true });
      });

    return () => {
      active = false;
    };
  }, [code]);

  if (!ready) return null;

  return (
    <ProfileShell>
      {isMegaMatch ? (
        <>
          <Silbina />
          <Footer />
        </>
      ) : (
        <>
          <Header />
          <Gallery />
          <Footer />
        </>
      )}
    </ProfileShell>
  );
}
